import React from 'react';
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const ExternalRedirect = ({ url, homePath = "/" }) => {
  const openedRef = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (openedRef.current) return;
    openedRef.current = true;

    // Attempt to open new tab
    const w = window.open(url, "_blank", "noopener,noreferrer");

    // If popup was allowed, go home automatically
    if (w && !w.closed) {
      navigate(homePath, { replace: true });
    } else {
      // If blocked, wait briefly and go home anyway
      setTimeout(() => navigate(homePath, { replace: true }), 1500);
    }
  }, [url, homePath, navigate]);

    return (
      <div style={{ padding: 16 }}>
        <button
          onClick={() => navigate(homePath, { replace: true })}
          style={{ marginLeft: 10, padding: "8px 14px", borderRadius: 8 }}
        >
          Return to Dave Friedel's Site
        </button>
      </div>
    );
};

export default ExternalRedirect;